import type { Prisma } from "@prisma/client";

export const projectFilter = {
	TOUS: "tous",
	DO: "do", 
	TRC: "trc",
	MRT: "mrt",
	GFA: "gfa",
} as const;

export const dashboardDocumentsSelect = {
	id: true,
	name: true,
	mimeType: true,
	createdAt: true,
	updatedAt: true,
	fileData: {
		select: {
			type: true,
		},
	},
	societies: {
		select: {
			type: true,
			society: {
				select: {
					id: true,
					denomination: true,
					brokerDetails: {
						select: {
							status: true,
						},
					},
				},
			},
		},
	},
	constructionSites: {
		select: {
			type: true,
			ConstructionSite: {
				select: {
					id: true,
					status: true,
					constructionSiteDetails: {
						select: {
							totalAmountTTC: true,
						},
					},
					constructionSiteClientDetails: {
						select: {
							clientType: true,
							clientSociety: {
								select: {
									denomination: true,
								},
							},
							constructionSiteClientContacts: {
								select: {
									constructionSiteContact: {
										select: {
											firstname: true,
											lastname: true,
										},
									},
								},
							},
						},
					},
				},
			},
		},
	},
	constructionSiteSubmissions: {
		select: {
			type: true,
			constructionSiteSubmission: {
				select: {
					id: true,
					constructionSiteId: true,
					constructionSite: {
						select: {
							id: true,
							status: true,
						},
					},
				},
			},
		},
	},
} satisfies Prisma.FileSelect;

export const dashboardProjectsSelect = {
	id: true,
	status: true,
	createdAt: true,
	updatedAt: true,
	constructionSiteDetails: {
		select: {
			totalAmountTTC: true,
		},
	},
	constructionSiteClientDetails: {
		select: {
			clientType: true,
			clientSociety: {
				select: {
					denomination: true,
				},
			},
			constructionSiteClientContacts: {
				select: {
					constructionSiteContact: {
						select: {
							firstname: true,
							lastname: true,
						},
					},
				},
			},
		},
	},
	propositions: {
		select: {
			id: true,
			reference: true,
			productType: true,
			status: true,
			assureurName: true,
			primeTTC: true,
			remunerationApporteur: true,
		},
	},
} satisfies Prisma.ConstructionSiteSelect; 

export const duneDocumentsSelect = {
	id: true,
	name: true,
	mimeType: true,
	createdAt: true,
	updatedAt: true,
	fileData: {
		select: {
			type: true,
		},
	},
	societies: {
		select: {
			type: true,
			society: {
				select: {
					id: true,
					denomination: true,
					brokerDetails: {
						select: {
							status: true,
						},
					},
				},
			},
		},
	},
	constructionSites: {
		select: {
			type: true,
			ConstructionSite: {
				select: {
					id: true,
					status: true,
					constructionSiteDetails: {
						select: {
							totalAmountTTC: true,
						},
					},
					constructionSiteClientDetails: {
						select: {
							clientType: true,
							clientSociety: {
								select: {
									denomination: true,
								},
							},
							constructionSiteClientContacts: {
								select: {
									constructionSiteContact: {
										select: {
											firstname: true,
											lastname: true,
										},
									},
								},
							},
						},
					},
				},
			},
		},
	},
	constructionSiteSubmissions: {
		select: {
			type: true,
			constructionSiteSubmission: {
				select: {
					id: true,
					constructionSiteId: true,
					constructionSite: {
						select: {
							id: true,
							status: true,
							constructionSiteClientDetails: {
								select: {
									clientSociety: {
										select: {
											denomination: true,
										}
									},
									constructionSiteClientContacts: {
										select: {
											constructionSiteContact: {
												select: {
													firstname: true,
													lastname: true,
												},
											},
										},
									}
								}
							}
						}
					},
				},
			},
		},
	},
	receptionLinks: {
		select: {
			id: true,
			constructionSiteId: true,
			ConstructionSite: {
				select: {
					id: true,
					status: true,
					constructionSiteClientDetails: {
						select: {
							clientSociety: {
								select: {
									denomination: true,
								}
							},
							constructionSiteClientContacts: {
								select: {
									constructionSiteContact: {
										select: {
											firstname: true,
											lastname: true,
										},
									},
								},
							}
						}
					}
				}
			},
		},
	},
	folder: {
		select: {
			id: true,
			name: true,
			constructionSiteSubmission: {
				select: {
					id: true,
					constructionSiteId: true,
					constructionSite: {
						select: {
							constructionSiteClientDetails: {
								select: {
									clientSociety: {
										select: {
											denomination: true,
										}
									},
									constructionSiteClientContacts: {
										select: {
											constructionSiteContact: {
												select: {
													firstname: true,
													lastname: true,
												},
											},
										},
									}
								}
							}
						}
					}
				},
			},
			receptionConstructionSite: {
				select: {
					id: true,
					status: true,
					constructionSiteClientDetails: {
						select: {
							clientSociety: {
								select: {
									denomination: true,
								}
							},
							constructionSiteClientContacts: {
								select: {
									constructionSiteContact: {
										select: {
											firstname: true,
											lastname: true,
										},
									},
								},
							}
						}
					}
				},
			},
		},
	},
	propositionDocuments: {
		select: {
			proposition: {
				select: {
					id: true,
					reference: true,
					status: true,
					productType: true,
					constructionSite: {
						select: {
							id: true,
							constructionSiteClientDetails: {
								select: {
									clientSociety: {
										select: {
											denomination: true,
										},
									},
									constructionSiteClientContacts: {
										select: {
											constructionSiteContact: {
												select: {
													firstname: true,
													lastname: true,
												},
											},
										},
									},
								},
							},
						},
					},
					gfaConstructionSite: {
						select: {
							id: true,
							constructionSiteClientDetails: {
								select: {
									clientSociety: {
										select: {
											denomination: true,
										},
									},
									constructionSiteClientContacts: {
										select: {
											constructionSiteContact: {
												select: {
													firstname: true,
													lastname: true,
												},
											},
										},
									},
								},
							},
						},
					},
				},
			},
		},
	},
} satisfies Prisma.FileSelect;

const dashboardConstructionSiteSelect = {
	id: true,
	constructionSiteDetails: {
		select: {
			totalAmountTTC: true,
		},
	},
	constructionSiteClientDetails: {
		select: {
			clientSociety: {
				select: {
					denomination: true,
				},
			},
			constructionSiteClientContacts: {
				select: {
					constructionSiteContact: {
						select: {
							firstname: true,
							lastname: true,
						},
					},
				},
			},
		},
	}
}
export const dashboardPropositionSelect = {
	id: true,
	reference: true,
	status: true,
	productType: true,
	primeTTC: true,
	createdAt: true,
	updatedAt: true,
	contractNumber: true,
	constructionSite: {
		select: dashboardConstructionSiteSelect
	},
	gfaConstructionSite: {
		select: dashboardConstructionSiteSelect
	},
} satisfies Prisma.PropositionSelect;

export const dashboardContractSelect = {
	id: true,
	reference: true,
	status: true,
	productType: true,
	primeTTC: true,
	contractNumber: true,
	contractStartDate: true,
	contractEndDate: true,
	createdAt: true,
	updatedAt: true,
	constructionSite: {
		select: dashboardConstructionSiteSelect
	},
	gfaConstructionSite: {
		select: dashboardConstructionSiteSelect
	},
} satisfies Prisma.PropositionSelect;


const dashboardSyndicConstructionSiteSelect = {
	id: true,
	constructionSiteDetails: {
		select: {
			totalAmountTTC: true,
			address: {
				select: {
					city: true,
				},
			},
		},
	},
	constructionSiteClientDetails: {
		select: {
			clientSociety: {
				select: {
					denomination: true,
				},
			},
		},
	},
}

export const dashboardSyndicPropositionSelect = {
	id: true,
	reference: true,
	status: true,
	productType: true,
	primeTTC: true,
	createdAt: true,
	updatedAt: true,
	constructionSite: {
		select: dashboardSyndicConstructionSiteSelect
	},
	gfaConstructionSite: {
		select: dashboardSyndicConstructionSiteSelect
	},
} satisfies Prisma.PropositionSelect;

export const dashboardSyndicContractSelect = {
	id: true,
	reference: true,
	status: true,
	productType: true,
	primeTTC: true,
	contractNumber: true,
	createdAt: true,
	updatedAt: true,
	constructionSite: {
		select: dashboardSyndicConstructionSiteSelect
	},
	gfaConstructionSite: {
		select: dashboardSyndicConstructionSiteSelect
	},
} satisfies Prisma.PropositionSelect;
